/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreContactAdd = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15 6h-2V4a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0V7h2a.5.5 0 0 0 0-1zM4.9 7.285c.558.656 1.647.656 2.205.001l1.233-2.115c.106-.182.162-.386.162-.592V2.676C8.5 1.628 7.156.778 6.002.778c-1.155 0-2.502.85-2.502 1.898l.003 1.905c0 .206.056.409.162.591l1.234 2.114zM10 15.518H2A.517.517 0 0 1 1.483 15v-3.162c0-.602.195-1.19.551-1.659l1.127-1.49a.519.519 0 0 1 .694-.123l1.391.9a1.388 1.388 0 0 0 1.508 0l1.391-.9a.518.518 0 0 1 .685.11l1.09 1.356c.385.48.597 1.091.597 1.72V15a.517.517 0 0 1-.517.518z"
    />
  </svg>
);

IconCoreContactAdd.displayName = 'IconCoreContactAdd';

IconCoreContactAdd.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreContactAdd);
IconCoreContactAdd.displayName = 'IconCoreContactAdd';
